import {AbstractControl, ValidationErrors} from '@angular/forms';

export function dateRangeValidator(control: AbstractControl): ValidationErrors | null {
    const startDate = control.get('startDate')?.value;
    const endDate = control.get('endDate')?.value;

    if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
        return {dateRange: true};
    }

    return null;
}

export function endDateAfterStartValidator(form: {get: (key: string) => AbstractControl | null}) {
    return (control: AbstractControl): ValidationErrors | null => {
        const startDate = form.get('startDate')?.value;
        const endDate = control.value;

        if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
            return {invalidEndDate: true};
        }

        return null;
    };
}
